import flatpickr from 'flatpickr'
import { Russian } from 'flatpickr/dist/l10n/ru'

flatpickr('.js-datepicker', {
  'locale': Russian, // locale for this instance only
  enableTime: false,
  altInput: true,
  altFormat: "j F Y",
  dateFormat: "Y-m-d",

})


